export default {
    TimeFormat: "YYYY/MM/DD HH:mm"
}